import Link from "next/link";
import Breadcrumb from "react-bootstrap/lib/Breadcrumb";
import style from "../../assets/stylesheets/core/breadcrumb.module.scss";

interface BreadcrumbItem {
  link: string;
  name: string;
  className: string;
}
interface BreadcrumbItems extends Array<BreadcrumbItem> {}
interface BreadcrumbContainerProps {
  items: BreadcrumbItems;
}

const BreadcrumbContainer = (props: BreadcrumbItem) => {
  const { className = "", items } = props;
  const renderBreadCrumbItem = (item, index) => {
    const isActive = index === items.length - 1;
    return (
      <Link href={item.link} key={index} passHref>
        <Breadcrumb.Item active={isActive} className={`breadcrumb-item ${style.uiBreadcrumbItem}`}>
          {isActive ? <span>{item.name}</span> : item.name}
        </Breadcrumb.Item>
      </Link>
    );
  };
  return (
    <Breadcrumb className={`${className} ${style.uiBreadcrumb}`}>
      {items.map(renderBreadCrumbItem)}
    </Breadcrumb>
  );
};

export default BreadcrumbContainer;
